import React from "react";
import { Container, Grid } from "@material-ui/core";
import CardFurnishers from "./CardFurnishers";
import NewFurnisher from "./NewFurnisher";
import { useRole } from "../../hooks/useRole";

export default function Furnishers() {
  const { isAdmin } = useRole();
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardFurnishers />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewFurnisher />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
